export default __webpack_public_path__ + "static/media/clients.fd25b13e.svg";